// extracted by mini-css-extract-plugin
export default {"anotherSaleBtn":"IconButtons_anotherSaleBtn__ufoBQ","iconBtn":"IconButtons_iconBtn__5p9JL","addIcon":"IconButtons_addIcon__gqzbh"};